const MB = 1024 * 1024;
export const MAX_IMAGE_SIZE = 15 * MB;
export const MAX_AUDIO_SIZE = 20 * MB;
export const MAX_DOCUMENT_SIZE = 25 * MB;
export const MAX_VIDEO_SIZE = 1024 * MB;
